import React from 'react';
import PropTypes from 'prop-types';
import * as S from './styled';
const SliderCard = /*#__PURE__*/React.forwardRef(({
  thumbnail,
  icon,
  title,
  brandName,
  pubDate
}, ref) => /*#__PURE__*/React.createElement(S.CardWrapper, {
  ref: ref
}, thumbnail && /*#__PURE__*/React.createElement(S.CardImageContainer, null, /*#__PURE__*/React.createElement(S.CardImage, {
  src: thumbnail,
  alt: `Afbeelding van ${title}`
}), icon && /*#__PURE__*/React.createElement(S.CardIconBox, null, icon)), /*#__PURE__*/React.createElement(S.CardBody, null, /*#__PURE__*/React.createElement("h2", null, title), (brandName || pubDate) && /*#__PURE__*/React.createElement(S.CardMeta, null, brandName && /*#__PURE__*/React.createElement("span", null, brandName), pubDate && pubDate))));
SliderCard.defaultProps = {
  icon: null,
  brandName: null,
  pubDate: null
};
SliderCard.propTypes = {
  thumbnail: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.node,
  brandName: PropTypes.string,
  pubDate: PropTypes.string
};
export default SliderCard;